<template>
  <section class="section-page-title bg-primary">
    <div class="container ">
      <div class="section-title page-title">
        <h1 class="h2-caslon text-white text-center f-44 fw-600">{{ title }}</h1>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps([
  'title'
])
</script>

<style scoped>

.section-page-title .page-title {
  padding: 100px 0 92px;
}
</style>